import { Route, Routes } from 'react-router-dom';
import { BusinessListPage } from './BusinessListPage/BusinessListPage';
import { BusinessDetailPage } from './BusinessDetailPage/BusinessDetailPage';

export enum BusinessContext {
    List = '',
    Detail = 'detail',
}

export const BusinessRoutes = () => {
    return (
        <Routes>            
            <Route path={ `/${BusinessContext.Detail}` } element={ <BusinessDetailPage /> } />
            <Route path={ `/${BusinessContext.List}` }element={<BusinessListPage />} />
        </Routes>
    );
};